import * as React from "react";
import { Header, Page } from "../../components";
import { useCopy } from "../../containers";

import "./success.scss";

interface ISuccessProps {
  copy: {
    message: string;
  };
}
const Success: React.FC<ISuccessProps> = ({ copy }) => {
  return (
    <Page className="success" width="medium" showHeader={false}>
      <Header copy={copy} />
    </Page>
  );
};

export const SuccessContainer: React.FC = () => {
  const copy = useCopy("success");

  return <Success copy={copy} />;
};
